module.exports = __webpack_public_path__ + "static/img/tab-service-s1.00cf085.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/tab-service-s1.png
// module id = JnHx
// module chunks = 0